export default __webpack_public_path__ + "static/media/Asset-79-2.99f5d36d.png";